import { Cohort } from 'nove8/constants/root-constants'
import { getFilteredCohortAbTestKeys } from 'nove8/helpers/getFilteredCohortAbTestKeys'
import { Countries } from 'root-constants'

export const getAbTestOptions = ({
  cohort,
  remoteConfigVariantValue,
  country,
  language,
}: {
  cohort: Cohort
  remoteConfigVariantValue: Record<string, string> | string
  country: string // will be needed for other cohorts
  language: string
}): Record<string, Record<string, string> | string> => {
  const keysArray = getFilteredCohortAbTestKeys(
    cohort,
    country as Countries,
    language,
  )

  if (!keysArray.length) return {}

  return Object.fromEntries(
    keysArray.map((key) => [
      key,
      typeof remoteConfigVariantValue === 'string'
        ? remoteConfigVariantValue
        : remoteConfigVariantValue[key],
    ]),
  )
}
